// import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: "fcdc6b60-441d-4ce7-b8c4-94b5fe8becee", // SiderExpress (Application/client ID)
    authority:
      "https://login.microsoftonline.com/461fd7ef-0eb3-4420-b044-310dc2914d64",
    redirectUri: "https://siderexpress.jelou.ai",
    // redirectUri: "http://localhost:3000/", // dev local
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // switch (level) {
        //     case LogLevel.Error:
        //         console.error(message);
        //         return;
        //     case LogLevel.Info:
        //         console.info(message);
        //         return;
        //     case LogLevel.Verbose:
        //         console.debug(message);
        //         return;
        //     case LogLevel.Warning:
        //         console.warn(message);
        //         return;
        // }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
